var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CornerLeftUpSvg from './corner-left-up.icon.svg';
export const CornerLeftUpIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: CornerLeftUpSvg });
};
_react_refresh_temp_1 = CornerLeftUpIcon;
$RefreshReg$(_react_refresh_temp_1, "CornerLeftUpIcon");
